import React from 'react'
import "../../styles/se_mechine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import cbsh from '../../img/cbsh.png'
import cbsv from '../../img/cbsv.png'
import cbsnf from '../../img/cbsnf.png'

export const Sealingmachine = () => {
    const des= {
        sam: ['mode -101H', 'Max Strap Size -Notstipulte', 'Min Strap Size 60*30','Strapping Speed - 1.5','Strap Width - 6-15' , 'Strap Force - 450','Dimension - 900*580*750/500'],
        cbsh:['Voltage - 220v/50hz','Power - 650','Sealing Speed -0~12(0.16)','Sealing Width - 8~10','Temperature Range - 0~300','Conveyor Size - 840*153','Film Thickness - 0.08','Dimension - 840*380*550','Net Weight - 32kg'],
        cbsv:['Voltage - 220v/50hz','Power - 650','Sealing Speed -0~12(0.16)','Sealing Width - 8~10','Temperature Range - 0~300','Conveyor Size - 840*153','Film Thickness - 0.08','Dimension - 840*380*550','Net Weight - 37'],
        cbsnf:['Voltage - 220v/50hz','Power - 750','Sealing Speed -0~12(0.16)', 'Sealing Width - 8~10','Temperature Range - 0~300','Conveyor Size - 840*153','Film Thickness - 0.08','Conveyor Loading - 5kg ','Net Weight - 50kg'],      
      }
  return (
    <div>
         <div className='prdmain2'>
      <div className='head3'>
        <h1>Continuous Band Sealing Machine</h1>
      </div>
      <div className='items2'>
        <Prodcard1
          imageSrc={cbsv}
          model={"VP 900V"}
          title="Continuous Band Sealer Vertical"
          altText="img of websit"
          description={des.cbsv}
        />
         <Prodcard1
          imageSrc={cbsh}
          model={"VP 900L"}
          title="Continuous Band Sealer Horizntal"
          altText="img of websit"
          description={des.cbsh}
        />
         <Prodcard1
          imageSrc={cbsnf}
          model={"VP 900vw"}
          title="Continuous Band Sealer Nitrogen Flushing"
          altText="img of websit"
          description={des.cbsnf}
        />
         {/* <Prodcard1
          imageSrc={cbsh}
          title=" band sealer with adjustable vertical stand"
          altText="img of websit"
          description={des.sam}
        /> */}

      </div>


    </div>

    </div>
  )
}
